import { render, staticRenderFns } from "./Component-MedicalResources.vue?vue&type=template&id=60ada5f9"
import script from "./Component-MedicalResources.vue?vue&type=script&lang=js"
export * from "./Component-MedicalResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports